const CHUNK_LOAD_MESSAGE_RE = /Loading (?:CSS )?chunk [^\s]+ failed/i;

export function isChunkLoadError(error: unknown): boolean {
  if (!error || typeof error !== 'object') return false;
  const err = error as { name?: unknown; message?: unknown };
  if (err.name === 'ChunkLoadError') return true;
  if (typeof err.message === 'string' && CHUNK_LOAD_MESSAGE_RE.test(err.message)) {
    return true;
  }
  return false;
}
